import React,{useState,useEffect} from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {useDispatch,useSelector} from 'react-redux';
import {Tooltip,withStyles,Typography} from '@material-ui/core';
import Aux from '../../../hoc/Auxilliary';
import { getEvents,
         clearErrorMessage,
         clearErrorStatusCode} from '../../../reduxSlices/alumniSlice';

import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import { clearLoginData, isLoggedInUpdate } from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import localizedStrings from "../../../utils/localize";

function Events({ event }) {

  return (
    <span>
    <HtmlTooltip title={<>
        <Typography> <strong>Title </strong>: {event.title}</Typography>
        <Typography> <strong>Start date </strong>: {moment(event.start).format('DD/MM/YYYY') }</Typography>
        <Typography> <strong>End date </strong>: {moment(event.end).format('DD/MM/YYYY')}</Typography>
        <Typography> <strong>Description </strong>: {event.description}</Typography>
        <Typography><strong>URL</strong>:  {event.url}</Typography>
    </>}>
    <strong>
    {moment(event.start).format("hh:mm A")} -  {moment(event.end).format("hh:mm A")}
    <br/>
    {event.title}
    </strong>
    </HtmlTooltip>
    </span>
  )
}

function EventAgenda({ event }) {

  return (
    <span>
      <em style={{ color: 'magenta' }}>{event.title}</em>
      <p>{event.ses_description}</p>
    </span>
  )
}

const localizer = momentLocalizer(moment);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);
const Event=(props)=>{
  const dispatch=useDispatch()
  const [events,setEvent]=useState([]);
    const [error, setError] = useState({
      isError: false,
      message: "",
      showSnackbar: false,
    });
    // console.log(state,"state")
    const errorMessage = useSelector((state) => state.alumniData.errorMessage);
    const eventsData = useSelector((state) => state.alumniData.events);
    console.log(eventsData,errorMessage)
    const errorStatusCode = useSelector(
      (state) => state.alumniData.errorStatusCode
    );
    const dataFetchingStatus = useSelector(
      (state) => state.alumniData.dataFetchingStatus
    );
    const [displayMessage, setDisplayMessage] = useState("");
    //current lagnguage
    const language = useSelector((state) => state.language.language);
    //set the current language to localize string
    localizedStrings.setLanguage(language);
    useEffect(() => {
      localizedStrings.setLanguage(language);
    }, [language]);

    
    useEffect(() => {
      if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
        if (errorStatusCode === 401) {
          let error = {
            isError: false,
            message: `${localizedStrings.general.sessionexpired}`,
            showSnackbar: true,
          };
          setError(error);
          setTimeout(() => {
            handelLogout();
          }, 1600);
        } else {
          let error = {
            isError: false,
            message: errorMessage,
            showSnackbar: true,
          };
          setError(error);
        }
      }
    }, [errorMessage, errorStatusCode]);

    useEffect(()=>{
      dispatch(getEvents());
    },[]);
    useEffect(()=>{
        if(eventsData&&eventsData.length>0){
          setEvent(eventsData.map(event=>{
            return {
              start:moment(event.ses_startdate).toDate(),
              end:moment(event.ses_enddate).toDate(),
              title:event.ses_eventtitle,
              description:event.ses_description,
              url:event.ses_eventurl
           
            }
          }) )
          
          
        }
    },[eventsData])

    const handelLogout = () => {
      dispatch(clearLoginData());
      window.localStorage.removeItem("x-auth-token");
      window.localStorage.removeItem("x-auth-fullname");
      window.localStorage.removeItem("x-auth-contactId");
      window.localStorage.removeItem("isUserLoggedIn");
      dispatch(isLoggedInUpdate(false));
      dispatch(clearErrorStatusCode());
      dispatch(clearErrorMessage());
      props.history.push("/login");
    };
    const handleClose = () => {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy); 
      dispatch(clearErrorStatusCode());
      dispatch(clearErrorMessage());
      
    };
    useEffect(() => {
      if (error.message === 'Invalid token') {
        setDisplayMessage(localizedStrings.general.invalidToken);
      }
      else if (error.message === 'Something Went Wrong') {
        setDisplayMessage(localizedStrings.general.somethingwentwrong);
      }
      else{
        setDisplayMessage(error.message);
      }
    }, [error]);
  return (
    <Aux>
    <MessageIndicator
          open={error.showSnackbar}
          message={displayMessage}
          handleClose={handleClose}
        />
        <Backdrop show={dataFetchingStatus} />
        <div style={{minHeight:'47vh',width:'100%',margin:'15px 0'}}>
        <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="month"
          events={events}
          components={{
            event: Events,
            agenda: {
              event: EventAgenda,
            },
          }}
          style={{ height: "100vh" }}
        />
    </div>
    </Aux>
  )
}

export default Event;